@if (navigationItem().type === navigationType.BUTTON || navigationItem().type === navigationType.ROUTE_KEY) {
    <button
        [attr.aria-label]="navigationItem().ariaLabel"
        (click)="navigationClicked.emit(navigationItem())"
        class="ap-header__menu-items-button"
        data-testid="header-menu-vertical-item"
    >
        {{ navigationItem().label }}
        <ng-container [ngTemplateOutlet]="badgeTemplate"></ng-container>
    </button>
}
@if (navigationItem().type === navigationType.LINK_SAME_TAB) {
    <a [href]="navigationItem()?.link" [attr.aria-label]="navigationItem().ariaLabel" (click)="navigationClicked.emit(navigationItem())">
        {{ navigationItem().label }}
        <ng-container [ngTemplateOutlet]="badgeTemplate"></ng-container>
    </a>
}
@if (navigationItem().type === navigationType.LINK_NEW_TAB) {
    <a
        rel="noopener noreferrer"
        target="_blank"
        [href]="navigationItem()?.link"
        [attr.aria-label]="navigationItem().ariaLabel"
        (click)="navigationClicked.emit(navigationItem())"
    >
        {{ navigationItem().label }}
        <ng-container [ngTemplateOutlet]="badgeTemplate"></ng-container>
        <div class="ap-sr-only">Opent in een nieuw tabblad</div>
    </a>
}
@if (includeParent() && navigationItem().type === navigationType.PARENT) {
    <button
        [attr.aria-label]="navigationItem().ariaLabel"
        (click)="navigationClicked.emit(navigationItem())"
        class="ap-header__menu-items-button"
        data-testid="header-menu-vertical-item"
    >
        {{ navigationItem().label }}
        <ng-container [ngTemplateOutlet]="badgeTemplate"></ng-container>
        <ap-icon class="ap-header__navigation-chevron--right" name="chevron-right" color="inherit" size="small"></ap-icon>
    </button>
}
@if (navigationItem().type === navigationType.SEARCH) {
    <button rel="noopener noreferrer" (click)="navigationClicked.emit(navigationItem())" class="ap-header__menu-items-button">
        <ap-icon name="magnifier" size="medium"></ap-icon>
        {{ navigationItem().label }}
    </button>
}
@if (includeParent() && navigationItem().type === navigationType.PARENT_ICON) {
    <ap-action-icon
        class="ap-header__navigation-icon"
        [ariaLabel]="navigationItem().ariaLabel"
        (click)="navigationClicked.emit(navigationItem())"
    >
        <ap-icon [name]="navigationItem().iconName" size="large"> </ap-icon>
        <ng-container [ngTemplateOutlet]="badgeTemplate"></ng-container>
        <ap-icon class="ap-header__navigation-chevron--right" name="chevron-right" color="inherit" size="small"> </ap-icon>
    </ap-action-icon>
}
@if (navigationItem().type === navigationType.LINK_ICON) {
    <ap-action-icon
        class="ap-header__navigation-icon"
        (click)="navigationClicked.emit(navigationItem())"
        [ariaLabel]="navigationItem().ariaLabel"
    >
        <ap-icon [name]="navigationItem().iconName" size="large"> </ap-icon>
        <ng-container [ngTemplateOutlet]="badgeTemplate"></ng-container>
    </ap-action-icon>
}

<ng-template #badgeTemplate>
    @if (navigationItem().badge) {
        <asn-badge data-testid="header-menu-vertical-badge">{{ navigationItem().badge }}</asn-badge>
    }
</ng-template>
